<div
  class="filter-sticky-stack"
  #filterStickyStack>
  <div class="filter-header">
    <div class="tabs compact">
      <nav
        mat-tab-nav-bar
        class="themed-tab-nav">
        <a
          mat-tab-link
          *ngFor="let tab of tabs$ | async"
          (click)="enableState(tab.value)"
          (touchstart)="enableState(tab.value)"
          [active]="(tabParam$ | async) == tab.value"
          [attr.data-cy]="
            'state-' + tab.value.toLowerCase() + '-toggle-button'
          ">
          <mat-icon
            [svgIcon]="tab.svgIcon"
            class="size-20"></mat-icon>
          {{ tab.label | i18n | titlecase }}
        </a>
      </nav>
    </div>
    <div class="filter-actions">
      <button
        mat-stroked-button
        class="filter-button"
        [class.collapsed]="filtersCollapsed$ | async"
        (click)="toggleFilters()"
        data-cy="dispo-jobs-index-collapse-filter-button"
        type="button">
        <div class="filter-button-content">
          <mat-icon svgIcon="filter_alt_outline"></mat-icon>
          <span class="mat-fab__label">{{ "filter" | i18n | titlecase }}</span>
          <span
            *ngIf="((filterCounts$ | async) || 0) > 0"
            class="badge"
            data-cy="count-badge">
            {{ filterCounts$ | async }}
          </span>
          <span
            *ngIf="(filterCounts$ | async) === 0"
            class="inverse-badge"
            data-cy="inverse-badge">
            -
          </span>
        </div>
      </button>

      <app-tab-toggle
        (click)="toggleView()"
        class="jobs-view-toggle">
        <app-tab-toggle-option
          [active]="(activeView$ | async) === 'tiles'"
          data-cy="jobs-view-toggle-tiles">
          <mat-icon
            svgIcon="tiles"
            size="20"
            class="toggle-icon"></mat-icon>
          {{ "tiles" | i18n | titlecase }}
        </app-tab-toggle-option>
        <app-tab-toggle-option
          [active]="(activeView$ | async) === 'list'"
          data-cy="jobs-view-toggle-list">
          <mat-icon
            svgIcon="jobs-list"
            size="20"
            class="toggle-icon"></mat-icon>
          {{ "list" | i18n | titlecase }}
        </app-tab-toggle-option>
      </app-tab-toggle>
    </div>
  </div>
  <div
    class="collapse-wrapper collapse-filter"
    [class.collapsed]="filtersCollapsed$ | async"
    [class.expanded]="!(filtersCollapsed$ | async)"
    (transitionend)="onFilterCollapseTransitionEnd($event)">
    <div class="collapse-child">
      <div class="row filter-bar">
        <div class="col-md-12">
          <app-date-range-select
            *ngIf="user$ | async"
            [useQueryParam]="'range'"
            [chips]="dateRangeChips"
            [selectedRange]="(selectedRange$ | async) ?? ''"
            data-cy="date-range-select"></app-date-range-select>
          <div class="dynamic-filter-row">
            <div class="dynamic-filter-item-small">
              <app-user-multiselect
                [lightFormField]="true"
                [useQueryParam]="'createdBy'">
              </app-user-multiselect>
            </div>
            <div class="dynamic-filter-item-small">
              <app-department-select
                [isMultiSelect]="true"
                [multiSelectVariant]="'select'"
                [lightFormField]="true"
                [selectedDepartmentIds]="(selectedDepartmentIds$ | async) || []"
                (departmentsSelectionChanged)="selectDepartments($event)"
                data-cy="jobs-index-department-select"></app-department-select>
            </div>
            <div class="dynamic-filter-item-small">
              <app-certificate-select
                [lightFormField]="true"
                [withIcon]="true"
                [useQueryParam]="'certificates'"></app-certificate-select>
            </div>
            <div class="dynamic-filter-item-small">
              <mat-form-field
                class="col light-form-field"
                data-cy="shift-input">
                <mat-label>{{ "shift" | i18n | titlecase }}</mat-label>
                <mat-select
                  [ngModel]="currentShift$ | async"
                  (ngModelChange)="currentShift$.next($event); enableShift()"
                  data-cy="shift-select">
                  <mat-option value="ALL">{{
                    "all" | i18n | titlecase
                  }}</mat-option>
                  <mat-option
                    *ngFor="let shift of shiftEnum | enumToArray"
                    [value]="shift">
                    {{ "shifts." + shiftEnum[shift] | i18n | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="dynamic-filter-item-small">
              <app-job-type-multiselect
                class="col"
                [lightFormField]="true"
                [useQueryParam]="'jobType'"
                data-cy="job-type-filter">
              </app-job-type-multiselect>
            </div>
            <div
              *ngIf="
                (readyCustomer$ | async) && (readyCustomer$ | async)?.branches
              "
              class="dynamic-filter-item-small">
              <mat-form-field
                class="light-form-field"
                data-cy="branch-input">
                <mat-label>{{ "branch" | i18n | titlecase }}</mat-label>
                <mat-select
                  [ngModel]="currentBranch$ | async"
                  (ngModelChange)="currentBranch$.next($event); enableBranch()"
                  data-cy="branch-select">
                  <mat-option value="ALL">{{
                    "all" | i18n | titlecase
                  }}</mat-option>
                  <mat-option
                    *ngFor="let branch of (readyCustomer$ | async)?.branches"
                    [value]="branch.id">
                    {{ branch.displayName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div
              class="dynamic-filter-item-small"
              *ngIf="
                (readyCustomer$ | async) &&
                ((readyCustomer$ | async)?.enableDemandReasons ||
                  (readyCustomer$ | async)?.enableJobRequestProcess)
              ">
              <app-demand-reason-select
                class="col"
                [lightFormField]="true"
                [useQueryParam]="'demandReason'"
                data-cy="demand-reason-input"></app-demand-reason-select>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="jobs-index__search-row">
            <mat-form-field class="search-input light-form-field">
              <label>
                <input
                  matInput
                  type="text"
                  [placeholder]="'search' | i18n | titlecase"
                  [ngModel]="searchText$ | async"
                  (ngModelChange)="searchText$.next($event); enableSearch()"
                  data-cy="job-search-input" />
              </label>
              <button
                mat-button
                matSuffix
                mat-icon-button
                aria-label="Search"
                (click)="enableSearch()">
                <mat-icon svgIcon="magnify"></mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field
              class="col search-type-select light-form-field"
              data-cy="search-type-input">
              <mat-label>
                {{ "searchType" | i18n | titlecase }}
              </mat-label>
              <mat-select
                [ngModel]="selectedSearchType$ | async"
                (ngModelChange)="
                  selectedSearchType$.next($event); enableSearch()
                "
                data-cy="search-type-select">
                <mat-option
                  *ngFor="let type of jobsSearchOptions$ | async"
                  [value]="type">
                  <span *ngIf="type === 'ALL'">
                    {{ "all_alternative" | i18n | titlecase }}
                  </span>
                  <span *ngIf="type !== 'ALL'">
                    {{ type.toLowerCase() | i18n | titlecase }}
                  </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="jobs-index__filter-row">
            <div class="jobs-index__show-canceled-jobs-checkbox">
              <mat-checkbox
                [ngModel]="showCanceledJobs$ | async"
                [checked]="!!(showCanceledJobs$ | async)"
                name="showCanceledJobs"
                data-cy="show-canceled-jobs-checkbox"
                (change)="toggleShowCanceledJobs($event)"
                *ngIf="(activeTab$ | async) === jobStatusEnum.ARCHIVED">
                {{ "showCanceledJobs" | i18n }}
              </mat-checkbox>
              <mat-checkbox
                [ngModel]="onlyShowCanceledJobs$ | async"
                [checked]="!!(onlyShowCanceledJobs$ | async)"
                name="onlyShowCanceledJobs"
                data-cy="only-show-canceled-jobs-checkbox"
                (change)="toggleOnlyShowCanceledJobs($event)"
                *ngIf="
                  (activeTab$ | async) === jobStatusEnum.ARCHIVED &&
                  (showCanceledJobs$ | async)
                ">
                {{ "onlyShowCanceledJobs" | i18n }}
              </mat-checkbox>
              <mat-checkbox
                [ngModel]="showOnlyActionRequiredBookableJobs$ | async"
                [checked]="!!(showOnlyActionRequiredBookableJobs$ | async)"
                name="showActionRequiredBookableOnly"
                data-cy="show-only-action-required-bookable-jobs-checkbox"
                class="allow-break"
                (change)="toggleShowOnlyActionRequiredBookableJobs($event)"
                *ngIf="(activeTab$ | async) === jobStatusEnum.OPEN"
                >{{ "showOnlyActionRequiredBookableJobs" | i18n }}
              </mat-checkbox>
              <mat-checkbox
                [ngModel]="showOnlyActionRequiredNoOpenInviteesJobs$ | async"
                [checked]="!!(showOnlyActionRequiredNoOpenInviteesJobs$ | async)"
                name="showActionRequiredNoOpenInviteesOnly"
                data-cy="show-only-action-required-no-open-invitees-jobs-checkbox"
                class="allow-break"
                (change)="toggleShowOnlyActionRequiredNoOpenInviteesJobs($event)"
                *ngIf="(activeTab$ | async) === jobStatusEnum.OPEN"
                >{{ "showOnlyActionRequiredNoOpenInviteesJobs" | i18n }}
              </mat-checkbox>
              <mat-checkbox
                [ngModel]="onyShowBookedJobs$ | async"
                [checked]="!!(onyShowBookedJobs$ | async)"
                name="onyShowBookedJobs"
                data-cy="show-only-booked-jobs-checkbox"
                (change)="toggleOnlyShowBookedJobs($event)"
                *ngIf="
                  (activeTab$ | async) === jobStatusEnum.ARCHIVED &&
                  !(showCanceledJobs$ | async)
                ">
                {{ "onyShowBookedJobs" | i18n }}
              </mat-checkbox>
              <mat-checkbox
                [ngModel]="showUnmappedJobs$ | async"
                [checked]="!!(showUnmappedJobs$ | async)"
                name="showUnmappedJobs"
                data-cy="show-unmapped-jobs-checkbox"
                (change)="toggleShowUnmappedJobs($event)"
                *ngIf="
                  (activeTab$ | async) !== jobStatusEnum.OPEN &&
                  (readyCustomer$ | async)?.enablePerigonApi
                ">
                {{ "showUnmappedJobs" | i18n }}
              </mat-checkbox>
              <mat-checkbox
                [ngModel]="showOnlyUnapprovedHours$ | async"
                [checked]="!!(showOnlyUnapprovedHours$ | async)"
                name="showOnlyUnapprovedHours"
                data-cy="show-only-unapproved-hours-checkbox"
                (change)="toggleShowOnlyUnapprovedHours($event)"
                *ngIf="(activeTab$ | async) === jobStatusEnum.ARCHIVED">
                {{ "showOnlyUnapprovedHours" | i18n }}
              </mat-checkbox>
            </div>
            <div class="flex-spacer"></div>
            <div class="filter-action-buttons">
              <button
                *ngIf="!(disableFilterSave$ | async)"
                mat-button
                class="save-filter-button"
                (click)="saveDefaultFilter()"
                data-cy="save-filter-button">
                <div class="filter-actions-button-content">
                  <mat-icon
                    svgIcon="save"
                    size></mat-icon>
                  {{ "saveDefaultFilter" | i18n | titlecase }}
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div
  class="jobs-list"
  data-cy="dispo-jobs-index">
  <div
    *ngIf="(daysList$ | async)?.length"
    class="jobs-index-sideline-container"
    [class.is-compact]="(activeView$ | async) === 'list'">
    <div class="jobs-index-sideline-start"></div>
    <div class="jobs-index-sideline"></div>
    <div class="jobs-index-sideline-end"></div>
  </div>
  <ng-container
    *ngIf="
      ($isLoadingJobs | async) &&
      !(allJobs$ | async)?.length &&
      (activeView$ | async) !== 'list'
    ">
    <p>{{ "loadingJobs" | i18n }}</p>
    <mat-spinner
      class="loading-spinner"
      data-cy="loading-jobs-spinner"
      diameter="24"></mat-spinner>
  </ng-container>
  <ng-container
    *ngIf="
      !($isLoadingJobs | async) &&
      !(allJobs$ | async)?.length &&
      (activeView$ | async) !== 'list'
    ">
    <p style="height: 100%">
      {{ "noJobsFound" | i18n }}
    </p>
  </ng-container>
  <div
    class="jobs-index-jobs-list"
    [class.list-view]="(activeView$ | async) === 'list'"
    data-cy="jobs-index-jobs-list">
    <div
      *ngIf="(activeView$ | async) === 'list'"
      class="jobs-list-view-header-row">
      <div
        *ngFor="let column of columns$ | async; trackBy: trackByColumnKey"
        class="job-list-view-header-column"
        [attr.data-column-key]="column.key"
        [class.with-small-spacing]="column.smallSpacing">
        <span>{{ column.key | i18n | titlecase }}</span>
        <div
          class="column-resize-handle"
          (mousedown)="onResizeStart($event, column.key)"></div>
      </div>
    </div>
    <div
      *ngIf="(activeView$ | async) === 'list'"
      class="jobs-list-view-header-row-bar"></div>
    <ng-container
      *ngFor="
        let day of daysList$ | async;
        let dayIndex = index;
        trackBy: trackByDate
      ">
      <div
        *ngIf="day.previousDateRangeStart"
        class="jobs-index-previous-date-range">
        <div>
          <span class="day-of-the-week">{{
            day.previousDateRangeStart | date: "EEE"
          }}</span>
          {{ day.previousDateRangeStart | date: "dd.MM.yyyy" }}
          <span class="calendar-week">
            {{ "calendarWeekShort" | i18n | titlecase }}
            {{ day.previousDateRangeStart | date: "ww" }}
          </span>
        </div>
        <div
          *ngIf="day.previousDateRangeEnd !== day.previousDateRangeStart"
          class="second-day">
          -
          <span class="day-of-the-week">{{
            day.previousDateRangeEnd | date: "EEE"
          }}</span>
          {{ day.previousDateRangeEnd | date: "dd.MM.yyyy" }}
          <span class="calendar-week">
            {{ "calendarWeekShort" | i18n | titlecase }}
            {{ day.previousDateRangeEnd | date: "ww" }}
          </span>
        </div>
      </div>
      <div
        class="jobs-index-day-header"
        data-cy="jobs-index-day-header"
        [style.--header-height.px]="
          (activeView$ | async) === 'list'
            ? jobsIndexListViewDayHeaderOffsetPx
            : jobsIndexDayHeaderTopPx ?? jobsIndexDayHeaderTopFallbackPx
        "
        [class.is-today]="day.date === (today$ | async)">
        <div class="day-start-circle"></div>
        <div>
          <span class="day-of-the-week">{{ day.date | date: "EEE" }}</span>
          {{ day.date | date: "dd.MM.yyyy" }}
          <span class="calendar-week">
            {{ "calendarWeekShort" | i18n | titlecase }}
            {{ day.date | date: "ww" }}
          </span>
        </div>
      </div>
      <div
        class="jobs-index-jobs-list-items"
        [attr.data-cy]="'jobs-index-date-list-' + day.date"
        *ngIf="
          (allJobs$ | async)?.length &&
          (jobsByDateMap$ | async) as jobsByDateMap
        ">
        <ng-container *ngIf="jobsByDateMap.get(day.date) as jobs">
          <div
            *ngFor="let job of day.jobIds; let i = index; trackBy: trackById">
            <app-dispo-job-list-item
              *ngIf="
                (jobsLoaderIsForActiveView$ | async) &&
                  (jobsLoader$ | async)?.loadedJobIds?.has(jobs[i]?._id);
                else jobSkeleton
              "
              data-cy="job-list-item"
              [job]="jobs[i]"
              [loggedInUser]="user$ | async"
              [routerLink]="'/jobs/' + jobs[i]._id"
              [compact]="(activeView$ | async) === 'list'"
              [columns]="(columns$ | async) || []"></app-dispo-job-list-item>
            <ng-template #jobSkeleton>
              <app-dispo-job-list-item-skeleton
                [compact]="
                  (activeView$ | async) === 'list'
                "></app-dispo-job-list-item-skeleton>
            </ng-template>
          </div>
        </ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="((allJobs$ | async)?.length || 0) >= limit">
      <div class="too-many-jobs">
        <mat-icon svgIcon="information-outline"></mat-icon>
        {{ "tooManyJobs" | i18n: { limit: limit.toString() } }}
      </div>
    </ng-container>
    <ng-container
      *ngIf="
        ($isLoadingJobs | async) &&
        !(allJobs$ | async)?.length &&
        (activeView$ | async) === 'list'
      ">
      <p>{{ "loadingJobs" | i18n }}</p>
      <mat-spinner
        class="loading-spinner"
        data-cy="loading-jobs-spinner"
        diameter="24"></mat-spinner>
    </ng-container>
    <ng-container
      *ngIf="
        !($isLoadingJobs | async) &&
        !(allJobs$ | async)?.length &&
        (activeView$ | async) === 'list'
      ">
      <p>
        {{ "noJobsFound" | i18n }}
      </p>
    </ng-container>
  </div>
</div>
<div
  class="floating-actions-bar"
  *ngIf="permissionsService.userHasEditJobPermission$() | async">
  <button
    class="primary-pill-button icon-left big-fab"
    routerLink="/jobs/new"
    type="button"
    data-cy="create-job-button">
    <mat-icon svgIcon="add-circle-plus"></mat-icon>
    {{ "createNewJob" | i18n | titlecase }}
  </button>
</div>
